import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./ProgressScroll.module.scss";

const ProgressScroll = ({ color }) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  React.useEffect(() => {
    const handleScroll = e => {
      var h = document.documentElement,
        b = document.body,
        st = "scrollTop",
        sh = "scrollHeight";

      var percent =
        ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;

      setScrollPosition(percent);
    };
    document.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.scroll}>
      <div
        style={{
          width: scrollPosition + "%",
          backgroundColor: color,
          transition: "width 0.2s"
        }}
      />
    </div>
  );
};

ProgressScroll.propTypes = {
  color: PropTypes.string.isRequired
};

export default ProgressScroll;
